






































































import { Component, Vue } from "vue-property-decorator";
import { State, namespace } from "vuex-class";
import AdditionalInfo from "@/views/tpp-claims/components/AdditionalInfo.vue";
import ClaimDisplay from "@/views/tpp-claims/components/ClaimDisplay.vue";
import IncidentInfo from "@/views/tpp-claims/components/IncidentInfo.vue";
import PropertyDamageInfo from "@/views/tpp-claims/components/PropertyDamageInfo.vue";
import { TPPClaims } from "@/models/tpp-claims/TPPClaims";
import TPPClaimsModule from "@/store/modules/tpp-claims";
import { TPPClaimsState } from "@/models/store/TPPClaimsState";
import TenantInfo from "@/views/tpp-claims/components/TenantInfo.vue";

const tppClaims = namespace(TPPClaimsModule.name);

@Component({
  name: "TPPClaimsView",
  components: { AdditionalInfo, ClaimDisplay, IncidentInfo, PropertyDamageInfo, TenantInfo }
})
export default class TPPClaimsView extends Vue {
  // ===== Props ===== //

  // ===== Store ===== //
  @State("tppClaims") private readonly tppClaims!: TPPClaimsState;
  @tppClaims.Action("handleCanEditClaimStatus") public handleCanEditClaimStatus!: (payload: boolean) => void;
  @tppClaims.Action("handleSelectedTPPClaim") public handleSelectedTPPClaim!: (payload: TPPClaims | {}) => void;
  @tppClaims.Action("handleNewClaimStatus") public handleNewClaimStatus!: (payload: string) => void;
  @tppClaims.Action("updateTPPClaimStatus") public updateTPPClaimStatus!: () => void;

  // ===== Data ===== //
  public attrs = {
    class: "mb-6",
    boilerplate: true,
    elevation: 2
  };

  // ===== Methods ===== //
  private handleEditTPPClaim(): void {
    this.handleCanEditClaimStatus(!this.tppClaims.canEditClaim);
  }

  private handleBackToIndex(): void {
    this.$router.push({ name: "tppClaimsIndex" });
    this.handleSelectedTPPClaim({});
    this.handleNewClaimStatus("");
  }

  private async handleUpdateTPPClaim(): Promise<void> {
    await this.updateTPPClaimStatus();
    this.$router.push({ name: "tppClaimsIndex" });
  }

  private handleCancelUpdateTPPClaim(): void {
    this.handleEditTPPClaim();
    this.handleNewClaimStatus("");
  }

  // ===== Computed ===== //
  get canEditClaim() {
    return this.tppClaims.canEditClaim;
  }

  // ===== Lifecycle ===== //
}
